import { createApi } from "@reduxjs/toolkit/query/react";
import type { CreateChatConversationRequest, CreateChatConversationResponse, GetChatConversationRequest, GetChatConversationResponse, ListChatConversationsRequest, ListChatConversationsResponse } from "../contracts";
import { baseQueryWithAuth } from "./api";

export const chatApi = createApi({
    reducerPath: "chatApi",
    baseQuery: baseQueryWithAuth,
    endpoints: builder => ({
        listChatConversations: builder.query<ListChatConversationsResponse, ListChatConversationsRequest>({
            query: body => ({
                url: "chat/list",
                method: "POST",
                body
            })
        }),
        getChatConversation: builder.query<GetChatConversationResponse, GetChatConversationRequest>({
            query: body => ({
                url: "chat/conversation",
                method: "POST",
                body
            })
        }),
        startChatConversation: builder.mutation<CreateChatConversationResponse, CreateChatConversationRequest>({
            query: body => ({
                url: "chat/conversation/start",
                method: "POST",
                body
            })
        })
    })
});

export const {
    useListChatConversationsQuery,
    useLazyListChatConversationsQuery,
    useGetChatConversationQuery,
    useLazyGetChatConversationQuery,
    useStartChatConversationMutation
} = chatApi;
